/**
 * Base class for thread management services
 */
export abstract class BaseThreadService<TThreadData, TPayload = unknown> {
    private threadCreationPromise: Promise<string> | null = null;

    getPersistedThread(storageKey: string): TThreadData | null {
        try {
            const stored = sessionStorage.getItem(storageKey);

            if (!stored) {
                return null;
            }

            const threadData = JSON.parse(stored) as TThreadData;

            return threadData;
        } catch (error) {
            console.error("Failed to parse persisted thread:", error);

            this.clearPersistedThread(storageKey);

            return null;
        }
    }

    persistThread(storageKey: string, threadData: TThreadData): void {
        try {
            sessionStorage.setItem(storageKey, JSON.stringify(threadData));
        } catch (error) {
            console.error("Failed to persist thread:", error);
        }
    }

    clearPersistedThread(storageKey: string): void {
        try {
            sessionStorage.removeItem(storageKey);
        } catch (error) {
            console.error("Failed to clear persisted thread:", error);
        }
    }

    protected abstract createThreadInternal(payload?: TPayload, options?: unknown): Promise<string>;

    async createThread(payload?: TPayload, options?: unknown): Promise<string> {
        // If a thread creation is already in progress, return that promise
        if (this.threadCreationPromise) {
            return this.threadCreationPromise;
        }

        this.threadCreationPromise = this.createThreadInternal(payload, options).finally(() => {
            this.threadCreationPromise = null;
        });

        return this.threadCreationPromise;
    }
}
